import { Link } from "react-router-dom";

// Minimal generic footer used on Landing, Assessment, Results, and every ContentPage
// (How It Works, Guides, FAQ, Privacy, Accessibility). Contains no Summit branding,
// address, phone, or logo. Includes the compliance-required Foundations Investment
// Advisors, LLC disclosure at the bottom.
export const MinimalFooter = () => {
  const linkStyle = {
    color: "#17233D",
    textDecoration: "none",
    fontWeight: 500,
    padding: "4px 0",
  };

  return (
    <footer
      role="contentinfo"
      style={{ background: "#ffffff", borderTop: "1px solid #e6edf5" }}
      data-testid="minimal-footer"
    >
      <div
        className="summit-container py-7 flex flex-col gap-5 md:flex-row md:items-center md:justify-between md:gap-6"
        style={{ color: "#17233D" }}
      >
        <div className="text-sm" style={{ color: "#17233D", fontWeight: 500 }} data-testid="footer-name">
          Financial Future Readiness Assessment
        </div>
        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm"
        >
          <span style={{ color: "#3a4d70" }} data-testid="footer-educational">Educational purposes only</span>
          <span aria-hidden="true" style={{ color: "#c7d3e2" }}>·</span>
          <Link to="/accessibility" style={linkStyle} data-testid="footer-accessibility">Accessibility</Link>
          <span aria-hidden="true" style={{ color: "#c7d3e2" }}>·</span>
          <Link to="/privacy" style={linkStyle} data-testid="footer-privacy">Privacy</Link>
          <span aria-hidden="true" style={{ color: "#c7d3e2" }}>·</span>
          <Link to="/financial-readiness-faq" style={linkStyle} data-testid="footer-faq">FAQ</Link>
        </nav>
      </div>

      <div style={{ borderTop: "1px solid #eef2f7" }}>
        <div
          className="summit-container py-6"
          style={{ color: "#3a4d70", fontSize: "0.82rem", lineHeight: 1.7, maxWidth: 1100 }}
          data-testid="foundations-disclosure"
        >
          Investment advisory services are offered through Foundations Investment Advisors, LLC (&ldquo;Foundations&rdquo;),
          an SEC registered investment advisor. Nothing on this website constitutes investment, legal or tax advice.
          Any historical performance data is solely illustrative and provided as general information and is not a
          prediction of any future results or any past results for any specific client of Foundations. This website
          and its contents do not make any recommendation that any particular security, portfolio of securities,
          transaction, investment or planning strategy is suitable for any specific person. Personalized investment
          advice can only be rendered after the engagement of Foundations, execution of required documentation
          (including a client agreement), and receipt of required disclosures. Investments in securities involve the
          risk of loss, including a total loss of money invested. Any past performance is no guarantee of future
          results. Advisory services are only offered to clients or prospective clients where Foundations and its
          advisors are properly licensed or exempt from licensure; Foundations reserves the right to accept or reject
          any prospective client. For more information about us, please go to{" "}
          <a
            href="https://adviserinfo.sec.gov"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1E1968", textDecoration: "underline", fontWeight: 500 }}
            data-testid="adviserinfo-link"
          >
            https://adviserinfo.sec.gov
          </a>{" "}
          and search by our firm name or by our CRD #175083.
        </div>
      </div>
    </footer>
  );
};

export default MinimalFooter;
